var $4d04f83e2a55769a$exports = {};
const $4d04f83e2a55769a$var$email = "qzehdxigrjmi.ztq@ta";
function $4d04f83e2a55769a$var$showContactAdress() {
    const p = document.querySelector(".contact");
    p.innerHTML += `Contact: <a href="mailto:${$4d04f83e2a55769a$var$decipher($4d04f83e2a55769a$var$email)}?subject=L.O.W">${$4d04f83e2a55769a$var$decipher($4d04f83e2a55769a$var$email)}</a>`;
}
function $4d04f83e2a55769a$var$decipher(txt) {
    const alpha = "abcdefghijklmnopqrstuvwxyz@-.";
    const cipher = "hsu@anwmopdfrqyit-xcbvzlke.gj";
    return txt.replace(/[a-z@\-\.]/gi, (l)=>cipher[alpha.indexOf(l)]);
}
$4d04f83e2a55769a$var$showContactAdress();


//# sourceMappingURL=index.65ed4432.js.map
